import { closeModal, openModal } from './modal';

export const closeExport = () => closeModal();

export const openExport = (node) => openModal('ExportDialog', { node });
